

const talentoData = [
    {
        "question": "Tú, en el centro",
        "answer": "Hemos escuchado tus plegarias y por fin se ha creado una solución pensando en la experiencia del candidato con procesos más rápidos, ver más allá del CV, minimizar los sesgos y que las capacidades transversales sean parte de la ecuación."
    },
    {
        "question": "Más historia, menos CV",
        "answer": "Cuéntanos todo en formato de audio o por escrito. ¡Nuestra IA analizará tu perfil y tomará en cuenta cada historia detrás del CV, así como todas tus expectativas para ayudarte a encontrar ese match perfecto!"
    },
    {
        "question": "Match sin sesgos",
        "answer": "Basta de CVs aburridos. Nuestro sistema te emparejará con las empresas que encajan mejor contigo, basado en tu experiencia, competencias transversales y tus objetivos, con un proceso anónimo y bidireccional."
    },
    {
        "question": "Experiencia gamificada",
        "answer": "¡Convierte tu búsqueda de empleo en una experiencia única! Publica tus historias, completa Assessments, acumula badges, recibe likes, interactúa con otros para ganar Wiibucks y canjéalos para desbloquear más funcionalidades."
    },
    {
        "question": "Visibilidad garantizada",
        "answer": "¡Ya no hace falta que seas Top Voice para dejar de ser invisible y olvídate de enviar CV’s como poseso! Nuestro sistema te permite conectar directamente con los recruiters que necesitan tu perfil y así destacar entre la multitud."
    },
    {
        "question": "¡Evalúa a los recruiters!",
        "answer": "Por primera vez podrás evaluar tus procesos de selección y ver la evaluación de otros, además de recibir consejos y feedback personalizados para que tu perfil brille y atraiga a tus matches ideales."
    },
]

export default talentoData;